import React from "react";

const BasicCarWash = () => {
  return (
    <div>
      <div>
        <p className="mt-2 mb-2 font-bold"> Pressure Wash</p>
        <ul className="list-disc text-black-500 ">
          <li className="font-bold">Exterior High Pressure Wash</li>
          <li className="font-bold">Exterior Foam Wash</li>
          <li className="font-bold">Exterior Glass Polish</li>
        </ul>
      </div>
    </div>
  );
};

export default BasicCarWash;
